export enum VSOCluster {
	CLUSTER_1 = 'CLUSTER_1',
	CLUSTER_2 = 'CLUSTER_2',
	CLUSTER_2_EMB = 'CLUSTER_2_EMB',
	CLUSTER_3 = 'CLUSTER_3',
	CLUSTER_3_4 = 'CLUSTER_3_4',
	CLUSTER_4 = 'CLUSTER_4',
}
